/*! @pentacode/ui v0.1.0 */
import { i as e, t } from "./styledElement-Dm1irIE2.js";
import { t as n } from "./decorateMetadata-BhwOl-pv.js";
import { t as r } from "./decorate-DHgd5sZx.js";
import { t as i } from "./css-build-DICbZE45.js";
import { LitElement as a, html as o } from "lit";
import { customElement as s, property as c, state as l } from "lit/decorators.js";
import { styleMap as u } from "lit/directives/style-map.js";
import { keyed as d } from "lit/directives/keyed.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/chart/chart-tooltip.css.js
var f = i(":host,[data-ts-chart-tooltip-portal=fallback]{--_chart-surface:var(--chart-tooltip-surface,var(--surface-1,var(--color-bg,Canvas)));--ts-chart-tooltip-background:var(--_chart-surface);--ts-chart-tooltip-color:var(--chart-tooltip-text,var(--color-fg,CanvasText));--ts-chart-tooltip-border:1px solid var(--border-color,color-mix(in srgb, currentColor 15%, transparent));--ts-chart-tooltip-border-radius:var(--border-radius);--ts-chart-tooltip-font:500 .8125rem / 1.3 var(--font-sans);--ts-chart-tooltip-active-row-font-weight:500;--ts-chart-tooltip-active-row-background:transparent;--ts-chart-tooltip-active-row-border-radius:0;--ts-chart-tooltip-active-row-shadow:none}.chart-tooltip-card{padding:var(--ts-chart-tooltip-padding,.4rem .55rem);border:var(--ts-chart-tooltip-border);border-radius:var(--ts-chart-tooltip-border-radius);background:var(--ts-chart-tooltip-background);color:var(--ts-chart-tooltip-color);box-shadow:var(--ts-chart-tooltip-shadow,0 6px 24px #00000024);font:var(--ts-chart-tooltip-font)}"), p = i(":host{color:var(--color-fg,CanvasText);font-family:var(--font-sans);--ts-chart-1:var(--chart-series-1,var(--blue));--ts-chart-2:var(--chart-series-2,var(--green));--ts-chart-3:var(--chart-series-3,var(--orange));--ts-chart-4:var(--chart-series-4,var(--teal));--ts-chart-5:var(--chart-series-5,var(--violet));--ts-chart-6:var(--chart-series-6,var(--red));--ts-chart-focus-fill:var(--_chart-surface);--ts-chart-crosshair-marker-fill:var(--_chart-surface);--ts-chart-crosshair-label-halo:var(--_chart-surface);display:block;position:relative}:host([hidden]){display:none}:host([fill]){min-block-size:0}:host([fill]) [part=chart]{position:absolute;inset:0}[part=empty]{color:var(--color-fg-muted,currentColor);place-items:center;display:grid}tanstack-chart{display:block}tanstack-chart .ts-chart__marks .ts-chart__text text{paint-order:stroke;stroke:var(--chart-label-halo,var(--color-bg,Canvas));stroke-width:4px;stroke-linejoin:round}tanstack-chart :is(path,rect,circle){transition:fill var(--duration-normal,.2s) ease, stroke var(--duration-normal,.2s) ease}"), m;
function h(e = () => import("./lit-fO1DLHHV.js")) {
	return m ??= e().then(({ defineChartElement: e }) => {
		customElements.get("tanstack-chart") || e();
	}, (e) => {
		throw m = void 0, e;
	}), m;
}
var g = class extends t(a) {
	constructor(...e) {
		super(...e), this.label = "", this.fill = !1, this._ready = !1, this._failed = !1, this._measuredHeight = 0, this._connection = 0, this._renderTooltip = (e) => o`<div class="chart-tooltip-card">${this.tooltip?.(e)}</div>`, this._resizeObserver = new ResizeObserver(([e]) => {
			this._measuredHeight = Math.floor(e?.contentRect.height ?? 0);
		}), this.styles = [f, p], this._handleSelect = (e) => this._dispatchPoint("chart-select", e), this._handleFocus = (e) => this._dispatchPoint("chart-focus", e);
	}
	connectedCallback() {
		super.connectedCallback();
		let t = this.ownerDocument, n = e(f, t);
		t.adoptedStyleSheets.includes(n) || (t.adoptedStyleSheets = [...t.adoptedStyleSheets, n]), this.hasUpdated && this._connection++, this.fill && this._resizeObserver.observe(this), h().then(() => {
			this._ready = !0, this._failed = !1;
		}, (e) => {
			console.error("[@pentacode/ui] ptc-ui-chart failed to load the chart runtime.", e), this._failed = !0;
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._resizeObserver.disconnect();
	}
	updated(e) {
		e.has("definition") && this.definition && !this.label && console.warn("[@pentacode/ui] ptc-ui-chart needs a label as its accessible name.", this), e.has("fill") && (this.fill ? this._resizeObserver.observe(this) : this._resizeObserver.unobserve(this));
	}
	get _chartHeight() {
		return this.fill ? this._measuredHeight || void 0 : this.height;
	}
	_dispatchPoint(e, t) {
		this.dispatchEvent(new CustomEvent(e, {
			detail: { point: t },
			bubbles: !0,
			composed: !0
		}));
	}
	render() {
		if (!this.definition || this._failed) return o`<div part="empty"><slot name="empty"></slot></div>`;
		if (!this._ready || this.fill && !this._measuredHeight) return o`<div
                part="chart"
                style=${u({ height: this._chartHeight ? `${this._chartHeight}px` : null })}
            ></div>`;
		let e = {
			definition: this.definition,
			ariaLabel: this.label,
			ariaDescription: this.description,
			height: this._chartHeight,
			renderTooltipBody: this.tooltip && this._renderTooltip,
			onSelect: this._handleSelect,
			onFocusChange: this._handleFocus
		};
		return d(this._connection, o`<tanstack-chart part="chart" .options=${e}></tanstack-chart>`);
	}
};
r([c({ attribute: !1 }), n("design:type", Object)], g.prototype, "definition", void 0), r([c(), n("design:type", Object)], g.prototype, "label", void 0), r([c(), n("design:type", String)], g.prototype, "description", void 0), r([c({ type: Number }), n("design:type", Number)], g.prototype, "height", void 0), r([c({
	type: Boolean,
	reflect: !0
}), n("design:type", Object)], g.prototype, "fill", void 0), r([c({ attribute: !1 }), n("design:type", Object)], g.prototype, "tooltip", void 0), r([l(), n("design:type", Object)], g.prototype, "_ready", void 0), r([l(), n("design:type", Object)], g.prototype, "_failed", void 0), r([l(), n("design:type", Object)], g.prototype, "_measuredHeight", void 0), r([l(), n("design:type", Object)], g.prototype, "_connection", void 0), g = r([s("ptc-ui-chart")], g);
var _ = g;
//#endregion
export { _ as n, h as r, g as t };

//# sourceMappingURL=chart-n8HIlsgg.js.map